import { useContext, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { MessageContext } from '@/helpers/MessageProvider';
import useMavLinkCommandHandler from '@/hooks/useMavLinkCommandHandler';
import useMavLinkTelemetryHandler from '@/hooks/useMavLinkTelemetryHandler';
import usePingListener from '@/hooks/usePingListener';
import useWaitingRobot from '@/hooks/useWaitingRobot';
import useWaitingRobotTimer from '@/hooks/useWaitingRobotTimer';

const useOrganizer = (robot) => {
  const address = useSelector((state) => state.telemetry[robot.id]?.address);
  const { publishCommand } = useContext(MessageContext);

  usePingListener(robot.id);
  useWaitingRobotTimer(robot.id);
  const isWaiting = useWaitingRobot(robot.id);

  useMavLinkTelemetryHandler(robot);
  const { addInterval, clearIntervals } = useMavLinkCommandHandler(robot);

  const [sysId, compId] = useMemo(() => {
    return [address?.sysId, address?.compId];
  }, [address]);

  useEffect(() => {
    if (!robot.isActive) return;
    if (isWaiting) return;
    if (!sysId) return;

    if (robot.isOwned) {
      publishCommand(robot, 'request/autopilot_version', [[sysId, compId]]);
    }

    addInterval('request/heartbeat', [[]], 1000);
    addInterval('request/message_interval', [[sysId, compId, 30, 200000]], 3000); // ATTITUDE
    addInterval('request/message_interval', [[sysId, compId, 31, 200000]], 3000); // ATTITUDE_QUATERNION
    addInterval('request/message_interval', [[sysId, compId, 32, 200000]], 3000); // LOCAL_POSITION_NED
    addInterval('request/message_interval', [[sysId, compId, 33, 200000]], 3000); // GLOBAL_POSITION_INT
    addInterval('request/message_interval', [[sysId, compId, 36, 200000]], 3000); // SERVO_OUTPUT_RAW

    return () => {
      clearIntervals();
    };
  }, [robot.isActive, isWaiting, sysId]);
};

export default useOrganizer;
